import * as React from 'react'

import Avatar from '../Avatar'
import Text from '../Text'

import getInterpunct from './get-interpunct'
import type { Interpunct } from './OrderedList'

interface Props {
  listingNumber: number
  badge: boolean
  interpunct: Interpunct
}

const OrderedListPrefix: React.FC<React.PropsWithChildren<Props>> = ({ badge, listingNumber, ...props }) => {
  const interpunct = getInterpunct(props.interpunct)
  const prefix = `${listingNumber}${interpunct}`
  return badge ? (
    <Avatar size="x-small" marginRight="dense">
      <Text is="span" color="white">
        {prefix}
      </Text>
    </Avatar>
  ) : (
    <Text is="span" marginRight="dense">
      {prefix}
    </Text>
  )
}

export default OrderedListPrefix
